import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import styles from './Footer.module.scss';

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  function handleBusinessInfoOPen() {
    window.open(
      'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8418703054&apv_perm_no=',
      '',
      'width=750,height=700',
    );
  }

  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'en';
    
    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <>
      <div className={`${styles.container} ${isMobile ? styles.isMobile : ''}`}>
        <div style={{ maxWidth: '850px', margin: '0 auto' }}>
          <div className={styles.companyInfoWrap}>
            <div className={styles.companyInfoTop}>
              <p className={styles.companyPhone}>
                {t('footer.customerCenter')}
              </p>
              <p className={styles.companyOpenTime}>
                {t('footer.operationHours')}
              </p>
            </div>
            <div className={styles.companyInfoBottom}>
              <div className={styles.companyName}>
                <p>{t('footer.company.name')}</p>
              </div>
              <div className={styles.companyInfoBottomContent}>
                <div className={styles.companyInfoLine}>
                  <span>{t('footer.company.ceo')}</span>
                </div>
                <div className={styles.companyInfoLine}>
                  <span>{t('footer.company.businessNumber')}</span>
                  <span
                    className={styles.businessInfo}
                    onClick={handleBusinessInfoOPen}
                  >
                    {t('footer.company.businessInfoCheck')}
                  </span>
                </div>
                {/* <div className={styles.companyInfoLine}>
                  <span>{t('footer.company.salesNumber')}</span>
                </div> */}
                <div className={styles.companyInfoLine}>
                  <span>{t('footer.company.address')}</span>
                </div>
                <div className={styles.companyInfoLine}>
                  <span>{t('footer.company.privacyOfficer')}</span>
                </div>
              </div>
              <span className={styles.copyright}>
              {t('footer.copyright')}
              </span>
            </div>
            <ul className={styles.navigation}>
              {/* <li onClick={() => navigate('/companyInfo')}>
                {t('footer.navigation.companyInfo')}
              </li> */}
              <li onClick={() => navigate('/terms')}>
                {t('footer.navigation.terms')}
              </li>
              {/* <li onClick={() => navigate('/guide')}>
                {t('footer.navigation.guide')}
              </li> */}
              {/* <li onClick={() => navigate('/unauthorizedEmailCollection')}>
                {t('footer.navigation.emailPolicy')}
              </li> */}
              <li onClick={() => navigate('/privacy')}>
                {t('footer.navigation.privacyPolicy')}
              </li>
              <li onClick={() => navigate('/commercial-transactions')}>
                {t('commercialTransactions.title')}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
export default Footer;
